<template>
  <div class="modal fade" data-backdrop="static" id="remediate" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info bg-danger">
            <h3 class="block-title"><i class="fa fa-edit"></i> Remediate</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" @click.prevent="clearData()" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Label</label>
              <input type="text" v-model="label" name="label" v-validate="'required'" data-vv-as="Label" class="form-control form-control-alt" placeholder="Label">
              <p v-if="errors.has('label')" class="errorMsg">{{ errors.first('label') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Remediation Method Name</label>
              <input type="text" v-model="remediationName" name="remediationName" v-validate="'required'" data-vv-as="Remediation Method Name" class="form-control form-control-alt" placeholder="Remediation Method Name">
              <p v-if="errors.has('remediationName')" class="errorMsg">{{ errors.first('remediationName') }}</p>  
            </div>
            <div class="form-group">
              <label>Remediation Steps</label>
              <input type="text" v-model="remediationSteps" class="form-control form-control-alt" placeholder="Remediation Steps">
            </div>
            <div class="form-group">
              <label>Remediation Date</label>
              <input type="text" id="remediate-date" name="date" v-model="date" placeholder="Move Date" class="form-control form-control-alt datepicker">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="remediate" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'RemediatePackage',
  data() {
    return {
      label: '',
      remediationName: '',
      remediationSteps: '',
      date: new Date().toJSON().slice(0,10),
      errorMsg: '',
      showModalLoader: false
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#remediate-date').change(function() { vm.date = $(this).val(); });
  },
  components: {
    HashLoader  
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    remediate() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/packages/remediate', {
            'PackageLabel': vm.label,
            'RemediationMethodName': vm.remediationName,
            'RemediationSteps': vm.remediationSteps,
            'RemediationDate': vm.date
          }).then((data) => {
            if (data.status === 'success') {
              jQuery('#remediate').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.showModalLoader = false;
              vm.clearData();
              vm.$emit('loadPackage', true);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    setData(label) {
      this.label = label;
    },
    clearData() {
      let vm = this;
      this.label = '';
      this.remediationName = '';
      this.remediationSteps = '';
      this.date = new Date().toJSON().slice(0,10);
      this.errorMsg = '';
      $('.datepicker').datepicker('update', vm.date);
      this.$validator.reset();
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/RemediatePackage.vue